// Ô "Tỉ lệ câu được nhắc sản phẩm" trong hộp Sửa bot (06/10/2026 — src/shared/ti-le-nhac-sp.ts, đi cùng BotPolicy.nhip): tách khỏi bots.ts để không phình tệp đó.
// Ô trống = theo Cài đặt trên máy bot (mặc định 33); 0 = không bao giờ nhắc; 100 = luôn nhắc (như cũ). Boss đặt thì thắng mức trên máy.
import { h } from "../dom";

export interface TruongNhacSanPham {
  /** Nhãn + ô nhập, để đặt vào hộp Sửa bot. */
  nhan: HTMLElement;
  o: HTMLInputElement;
  /** Giá trị cho chuanHoaNhipBoss: null (ô trống) hoặc số đang gõ (chuanHoaNhipBoss tự kiểm số nguyên 0–100). */
  doc(): number | null;
}

export function truongNhacSanPham(hienTai: number | undefined): TruongNhacSanPham {
  const o = h("input", {
    type: "number", min: 0, max: 100, step: 1, value: hienTai === undefined ? "" : String(hienTai), placeholder: "theo máy bot",
    title: "Kịch bản có gắn sản phẩm: trước MỖI câu bình luận/trả lời do AI soạn, bot tự bốc — trúng tỉ lệ này thì AI được nhắc sản phẩm tự nhiên, trượt thì AI nhận lệnh KHÔNG nhắc tên sản phẩm (câu còn tên bị loại, soạn lại). 0 = không bao giờ nhắc, 100 = luôn nhắc; để trống = theo Cài đặt trên máy bot (mặc định 33).",
    "data-testid": "edit-ti-le-nhac-sp",
  }) as HTMLInputElement;
  const nhan = h("label", { class: "f" }, h("span", {}, "Tỉ lệ câu được nhắc sản phẩm (%, 0–100)"), o);
  return { nhan, o, doc: () => (o.value.trim() === "" ? null : Number(o.value)) };
}
